import { createUseStyles } from 'react-jss';
import { Theme } from '@mui/material';

export const useStyles = createUseStyles((theme: Theme) => {
    const { color, radius, motion, font } = theme.custom;
    return {
        container: { maxHeight: 'calc(100vh - 360px)', minHeight: 240 },
        row: { cursor: 'pointer' },
        idLink: {
            fontFamily: font.mono,
            fontWeight: 600,
            color: color.text.primary,
            textDecoration: 'none',
            whiteSpace: 'nowrap',
            '&:hover': { color: color.primary.main, textDecoration: 'underline' },
        },
        email: { overflowWrap: 'anywhere' },
        date: { whiteSpace: 'nowrap', fontVariantNumeric: 'tabular-nums' },
        cards: { display: 'flex', flexDirection: 'column', gap: 10, padding: 12 },
        card: {
            display: 'block',
            width: '100%',
            textAlign: 'left',
            padding: 14,
            borderRadius: radius.md,
            border: `1px solid ${color.border}`,
            backgroundColor: color.surfaceRaised,
            fontFamily: 'inherit',
            transitionProperty: 'border-color',
            transitionDuration: motion.fast,
            '&:hover': { borderColor: color.primary.main },
        },
        cardTop: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 10, marginBottom: 8 },
        cardMeta: { fontSize: 12, color: color.text.secondary, display: 'flex', flexWrap: 'wrap', gap: '2px 10px' },
    };
});
